import { InstructionalFeatureCheckbox } from "./InstructionalFeatureCheckbox.component";

export { InstructionalFeatureCheckbox };
